import { render, staticRenderFns } from "./addorder.vue?vue&type=template&id=a17a3efc&scoped=true&"
import script from "./addorder.vue?vue&type=script&lang=js&"
export * from "./addorder.vue?vue&type=script&lang=js&"
import style0 from "./addorder.vue?vue&type=style&index=0&id=a17a3efc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17a3efc",
  null
  
)

export default component.exports